// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inventory-item-actions[data-v-deb32068] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.inventory-item-actions__edit[data-v-deb32068] {\n    margin-right: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
